const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGreenEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.19952 42.8584C10.9106 51.6954 20.219 57.707 30.9352 57.707C46.4048 57.707 58.945 45.1701 58.945 29.707C58.945 14.244 46.4048 1.70703 30.9352 1.70703C17.3969 1.70703 6.10524 11.3048 3.49121 24.0661",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.30051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7349 1.85677C28.133 1.12198 25.9546 5.79082 25.9546 5.79082C24.7094 7.03605 22.6871 8.50563 21.185 8.9218C19.4261 9.40949 15.8692 11.9975 15.8692 13.8215C15.8692 14.6018 16.643 15.148 17.3778 14.8846C17.3778 14.8846 24.937 10.9734 27.3917 12.5632C28.0354 12.9826 29.375 14.1368 30.8933 14.0328C32.1841 13.945 34.8144 13.8962 36.0563 14.3189C39.3369 15.4341 39.8473 19.9501 37.8575 19.2348C35.7052 18.4643 34.3527 16.5525 30.3081 19.7876C28.754 21.0361 26.9853 20.7272 26.9853 20.7272C25.3304 20.7239 25.5222 18.6951 25.3596 17.8953C25.1711 16.9622 24.0266 16.6826 23.0935 16.8679C19.3025 17.6255 13.2714 20.3988 12.8812 28.1921C12.5691 34.4151 17.3615 34.0444 19.7317 33.4982C22.7716 32.7959 26.2635 35.3449 27.1056 38.5767C27.7298 40.9664 27.1966 45.6125 28.094 48.2688C29.1539 51.403 31.8882 53.4155 34.0438 50.9023C35.91 48.7239 38.2412 47.1731 39.0248 45.6125C39.6458 44.3672 40.335 39.9585 40.335 39.9585C40.4911 38.8238 41.0568 38.0988 41.9216 37.3477C43.2417 36.2033 45.2314 36.1935 46.4474 34.3468C47.4293 32.8577 47.4293 30.3705 45.7582 30.5525C39.3369 30.9915 38.4038 25.3928 38.8654 24.0272C39.2198 22.9738 40.5496 22.925 41.0861 23.9004C42.7637 26.9501 45.6996 27.3305 47.1204 27.259C47.9203 27.22 50.2319 27.259 50.544 25.7049C50.8562 24.1508 49.5459 22.8535 49.6109 21.9724C49.7084 20.6719 52.5273 21.5628 53.3466 22.5934C54.6146 24.1898 53.9676 26.9501 55.59 29.3788C56.3216 30.4778 58.6397 31.9278 58.6397 31.9278",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.30051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1961 56.0423C14.0874 56.7479 12.3382 57.1998 10.3192 56.6471C1.24485 54.1761 -0.0719203 40.7418 3.69956 32.1064C3.69956 32.1064 3.8101 35.3837 8.635 38.9114C13.19 42.2374 18.909 40.5468 21.9945 45.9569C22.9374 47.6118 22.8626 49.361 22.3359 50.8728C21.5816 53.0252 19.1236 54.4297 16.9193 53.955",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.30051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenEarth);
export default __webpack_public_path__ + "static/media/icon-green-earth.68f1ab714fac1473a0972610f769d9cb.svg";
export { ForwardRef as ReactComponent };